import { render, staticRenderFns } from "./translation_setting.vue?vue&type=template&id=a0f2e8d2&scoped=true&"
import script from "./translation_setting.vue?vue&type=script&lang=js&"
export * from "./translation_setting.vue?vue&type=script&lang=js&"
import style0 from "./translation_setting.vue?vue&type=style&index=0&id=a0f2e8d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f2e8d2",
  null
  
)

export default component.exports